(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorDeleteController',GestorDeleteController);

    GestorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gestor', 'Unidadegestor'];

    function GestorDeleteController($uibModalInstance, entity, Gestor, Unidadegestor) {
        var vm = this;

        vm.gestor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        vm.id = null;
        vm.login = null;
        vm.onSuccessUnidades = onSuccessUnidades;
        vm.finalizar = finalizar;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {

            Unidade.queryUGsAssociadas({idGestor: id}, onSuccessUnidades);

            /*Gestor.delete({id: id},
                
                function () {
                    $uibModalInstance.close(true);
                });
                */
        }

        function onSuccessUnidades(result){
            Unidadegestor.acao({acao: "delete"}, result, finalizar);
        }

        function finalizar(){
            Gestor.delete({id: vm.id},
                // TO-DO
                function () {
                    User.delete({login: vm.login});
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();
